module.exports = __webpack_public_path__ + "static/media/21ECLAC24.fa5f3bf1.jpg";